// Validate tags are not empty strings and that there are no duplication
const validateTags = (config) => {
  const { items } = config;

  if (!items) {
    return new Error('Missing items');
  }

  const found = [];

  for (const item of items) {
    const { tag } = item;

    if (!tag.trim()) {
      return new Error('Tag must not be empty');
    }

    if (found.indexOf(tag) > -1) {
      return new Error('Tag names must not be duplicated');
    }

    found.push(tag);
  }

  return null;
};

module.exports = { validateTags };



// WEBPACK FOOTER //
// ./common/validation/tags.js